export default __webpack_public_path__ + "static/media/07.be079e11.jpg";